// import axios from 'axios';
const API_URL = 'https://api.abra.slox.cz/BazarCD'
const DISCOGS_API_URL = 'https://api.discogs.com'
const DISCOGS_API_TOKEN = 'kARUCRaUBarwjiQznIaReBdGZzJLhmjJISvVjxit'

export default {
  API_URL: API_URL,
  DISCOGS_API_URL: DISCOGS_API_URL,
  DISCOGS_API_TOKEN: DISCOGS_API_TOKEN
};